// Giá trị `level` chuẩn: form tạo trường lưu các giá trị này và import quy về chúng.
export const SCHOOL_LEVELS = [
  { value: 'elementary', label: 'Tiểu học' },
  { value: 'middle', label: 'Trung học cơ sở' },
  { value: 'high', label: 'Trung học phổ thông' },
  { value: 'university', label: 'Đại học' },
  { value: 'college', label: 'Cao đẳng' },
  { value: 'vocational', label: 'Dạy nghề' },
] as const;

// Cách ghi khác đã gặp trong dữ liệu cũ (vd seed lưu `primary`) và file Excel.
const SCHOOL_LEVEL_ALIASES: Record<string, string> = {
  primary: 'elementary',
  primary_school: 'elementary',
  elementary_school: 'elementary',
  middle_school: 'middle',
  high_school: 'high',
  th: 'elementary',
  'cấp 1': 'elementary',
  thcs: 'middle',
  'cấp 2': 'middle',
  thpt: 'high',
  'cấp 3': 'high',
  'đh': 'university',
  'cđ': 'college',
};

const toKey = (text: string) => text.normalize('NFC').trim().toLowerCase().replace(/\s+/g, ' ');

/** Quy giá trị chuẩn, nhãn tiếng Việt hoặc alias về giá trị chuẩn; không nhận ra thì trả undefined. */
export const normalizeSchoolLevel = (level?: string | null): string | undefined => {
  if (!level) return undefined;
  const key = toKey(level);
  const match = SCHOOL_LEVELS.find((item) => item.value === key || toKey(item.label) === key);
  return match?.value ?? SCHOOL_LEVEL_ALIASES[key];
};

export const isStandardSchoolLevel = (level: string): boolean =>
  SCHOOL_LEVELS.some((item) => item.value === level);

export const getSchoolLevelLabel = (level?: string | null): string => {
  const value = normalizeSchoolLevel(level);
  return SCHOOL_LEVELS.find((item) => item.value === value)?.label ?? level ?? '';
};
